import React, { Component } from 'react'
import AsLegendSizeContinuousPoint from './airship-wrappers/AsLegendSizeContinuousPoint'
import numeral from 'numeral';
import { connect } from 'react-redux';
import { withCarto } from '../carto/withCarto';

export class DpsLegendSizeContinuousPoint extends Component {
  state = {
    data: null
  }

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.CartoContext.layers[this.props.layer].on('metadataChanged', this.updateLegendData)
  }

  componentWillUnmount() {
    this.props.CartoContext.layers[this.props.layer].off('metadataChanged', this.updateLegendData)
  }

  updateLegendData = (event) => {
    let data;
    event.styles.forEach(function (styleMetadata) {
      switch(styleMetadata.getProperty()) {
        case 'marker-width':
          data = styleMetadata.getBuckets().map(bkt => ({label: numeral(bkt.max*1000).format('0.0a'), width: bkt.value}))
          break;
        // case 'marker-fill':
        //   data = data.map((bkt, i) => ({...bkt, color: styleMetadata.getBuckets()[i].value, strokeColor: '#fff'}))
        //   break;
        default:
          break;
      }
    });
    this.setState(state => ({
      ...state,
      data: data
    }))
  }

  render() {
    return (
      <div style={{display: 'flex', alignItems: 'flex-end'}}>
        <AsLegendSizeContinuousPoint ref={this.ref} data={this.state.data} slot="legends" orientation="horizontal" scale="1"></AsLegendSizeContinuousPoint>
      </div>
      
    )
  }
}

const mapStateToProps = state => ({
  layers: state.carto.layers
});

export default connect(mapStateToProps)(withCarto(DpsLegendSizeContinuousPoint));
